module.exports = __webpack_public_path__ + "img/neogeo_logo.d40916e3.png";